<template>
  <div id="deliverySite">
    <nav>
      <!--      <span :class="type == 1 ? 'active' : ''" @click="type = 1">{{-->
      <!--        $fanyi("收件人")-->
      <!--      }}</span-->
      <!--      ><span :class="type == 2 ? 'active' : ''" @click="type = 2">{{-->
      <!--        $fanyi("进口商")-->
      <!--      }}</span>-->
    </nav>
    <div class="con">
      <div
        class="opt"
        v-for="(item, index) in consignee"
        :key="index"
        :class="{ acquiescent: item.acquiescent }"
      >
        <div class="h1Title">
          <span>{{ $fanyi("地址") }}{{ index + 1 }}</span>
          <span class="defaultAddress" v-if="item.acquiescent">
            {{ $fanyi("当前默认地址") }}
          </span>
        </div>
        <p>
          <label for="">{{ $fanyi("收件人") }}：</label>
          <span :title="item.contacts">{{ item.contacts }}</span>
        </p>
        <p>
          <label for="">{{ $fanyi("邮编") }}：</label>
          <span :title="item.zip_code">{{ item.zip_code }}</span>
        </p>
        <p>
          <!-- 城市 -->
          <label for="">{{ $fanyi("城市") }}：</label>
          <span :title="item.city">{{ item.city }}</span>
        </p>
        <p>
          <label for="">{{ $fanyi("省份") }}：</label>
          <span :title="item.province">{{ item.province }}</span>
        </p>
        <p>
          <label for="">{{ $fanyi("国家") }}：</label>
          <span :title="item.country">{{ item.country }}</span>
        </p>
        <p class="address">
          <label for="">{{ $fanyi("地址") }}：</label>
          <span :title="item.address">{{ item.address }}</span>
        </p>
        <p>
          <label for="">{{ $fanyi("电话") }}：</label>
          <span :title="item.mobile">{{ item.mobile }}</span>
        </p>
        <p class="address">
          <!-- 电子邮件 -->
          <label for="">{{ $fanyi("电子邮件") }}：</label>
          <span :title="item.email">{{ item.email }}</span>
        </p>
        <div class="btn">
          <el-button class="uiBtn uiGreen2" @click="edit(item)">{{
            $fanyi("编辑")
          }}</el-button>
        </div>
      </div>
      <div class="add opt" @click="openAddAddressWin">
        <div>
          <img src="../../../../assets/user-img/tianJia.svg" alt="" />
          <span>{{ $fanyi("新增地址") }}</span>
        </div>
      </div>
    </div>
    <DeliverySiteAddressDialog
      ref="addressDialog"
      :address-type="type"
      @success="useraddressList"
    />
  </div>
</template>

<script>
import DeliverySiteAddressDialog from "./components/DeliverySiteAddressDialog.vue";

export default {
  components: {
    DeliverySiteAddressDialog,
  },
  data() {
    return {
      type: 1,
      consignee: [],
      importer: [],
    };
  },

  created() {
    this.useraddressList();
  },
  methods: {
    openAddAddressWin() {
      this.$refs.addressDialog.openAdd();
    },
    edit(item) {
      this.$refs.addressDialog.openEdit(item);
    },
    synchronization(item) {
      let msg = this.type == 2 ? "收件人" : "进口商";
      item.type = this.type == 2 ? 1 : 2;
      item.acquiescent = 0;
      this.$confirm(this.$fanyi("是否同步到" + msg), this.$fanyi("提示"), {
        confirmButtonText: this.$fanyi("确定"),
        cancelButtonText: this.$fanyi("取消"),
        type: "warning",
        center: true,
      }).then(() => {
        this.$api.useraddressAdd(item).then((res) => {
          if (res.code != 0)
            return this.$message.error(this.$fun.apiErrorMsg(res.msg));

          this.useraddressList();
          this.$message.success(this.$fanyi("保存成功"));
        });
      });
    },
    useraddressList() {
      this.consignee = [];
      this.importer = [];
      this.$api.useraddressList().then((res) => {
        if (res.data.consignee) {
          this.consignee = res.data.consignee;
        }
        if (res.data.importer) {
          this.importer = res.data.importer;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../css/mixin";
#deliverySite {
  background-color: #f8f7f7;
  nav {
    display: flex;
    span {
      display: block;
      width: 130px;
      height: 50px;
      background: #e8e8e8;
      border: 1px solid #e1e1e1;
      border-bottom: none;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      &.active {
        background: #ffffff;
      }
    }
  }
  .con {
    background-color: white;
    display: flex;
    flex-wrap: wrap;
    padding: 20px;
    border: 1px solid #eaecf0;
    border-radius: 12px;
    > .opt {
      width: 319px;
      background: #ffffff;
      border: 1px solid $homePageSubjectColor;
      border-radius: 10px;
      padding: 24px;
      display: flex;
      flex-direction: column;
      margin-right: 20px;
      margin-bottom: 20px;
      .h1Title {
        height: unset;
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
          width: max-content;
          font-size: 18px;
          font-weight: bold;
          color: #000000;
        }
        span.defaultAddress {
          @extend .dip;
          width: max-content;
          padding: 0 8px;
          height: 24px;
          border: 1px solid #ffa018;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 400;
          text-align: center;
          color: #ffa018;
        }
      }
      p {
        display: flex;
        margin-bottom: 12px;
        label {
          display: inline-block;
          flex: 0 0 120px;
          font-size: 14px;
          line-height: 20px;
          font-weight: 400;
          margin-right: 10px;
        }
        span {
          display: block;
          flex: 1;
          min-width: 0;
          font-size: 14px;
          line-height: 20px;
          font-weight: 400;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &.address {
          max-height: none;
          align-items: flex-start;
          span {
            white-space: normal;
            word-break: break-word;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
      .btn {
        text-align: left;
        .uiBtn {
          height: 36px;
          border-radius: 8px;
          font-size: 14px;
          padding: 0 16px;
          line-height: 20px;
        }
      }
      &.add {
        cursor: pointer;
        background: #ffffff;
        border: 1px solid #eaecf0 !important;
        text-align: center;
        min-height: 430px;
        align-items: center;
        justify-content: center;
        > div {
          cursor: pointer;
        }
        img {
          width: 32px;
          height: 32px;
          display: block;
          margin: 0 auto 16px;
        }
        span {
          font-size: 18px;
          font-weight: 600;
          color: #d0d5dd;
        }
      }
    }
    .acquiescent {
      background-color: #fcfcff;
    }
  }
}
</style>
